<ngx-slick-carousel class="testimonial-slider carousel" [ngClass]="{ 'orange-dots': isOrange }" #slickModal="slick-carousel" [config]="slideConfig">
    <div ngxSlickItem *ngFor="let slide of slides" class="slide">
        <div class="slides">
            <a [href]="slide.link" target="_blank" rel="noopener noreferrer"
                class="trpx-activity-card text-decoration-none">

                <div class="slide-image"
                    [ngStyle]="{background: 'url('+ slide.image + ')' + 'no-repeat center / cover,#cccccc'}">
                </div>
            </a>
            <div class="slider-content">
                <div class="description">
                    {{slide.description}}
                </div>
                <div class="d-flex" *ngIf="slide?.author">
                    <div class="author-image">
                        <img src="{{ slide?.iconUrl }}" class="img-fluid" alt="">
                    </div>
                    <div>
                        <div class="author-name">{{slide?.author}}</div>
                        <div class="author-description">{{slide?.heading}}</div>
                    </div>
                </div>
                <div class="author-name" *ngIf="slide?.diney_heading">
                    {{slide?.diney_heading}}
                </div>
            </div>
            <!-- </a> -->
        </div>

    </div>
</ngx-slick-carousel>